let language = {

    POP_UP_BUTTON_OK: "OK",
    POP_UP_BUTTON_CANCEL: "Cancel",    
    POP_UP_BUTTON_SUBMIT: "Submit",
    POP_UP_BUTTON_ENABLE: "Enable",
    POP_UP_BUTTON_SURE: "Sure",
};

export { language } 